<!--
 * @Author: GeekMzy
 * @Date: 2024-04-22 14:17:29
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\login.vue
-->
<template>
  <div class="login" @keydown.enter="handleSubmit">
    <!-- <div class="app_download" @click="showCode = !showCode">APP下载</div>
    <div v-show="showCode" class="app_qrcode">
      <img src="http://119.84.149.201:18088/api/app/openapi/app/version/qr-code" alt="app下载二维码" />
    </div> -->
    <div class="login-con">
      <el-card icon="log-in" :bordered="false" style="box-shadow: 0px 0px 6px #00237031">
        <div class="title" slot="title">
          <img :src="logoSrc" style="display: inline-block; width: 50px; height: 50px; margin: 0 20px 0 45px" />
          <div>{{ title }}</div>
        </div>
        <div class="form-con">
          <el-form ref="loginForm" :model="form" :rules="rules">
            <el-form-item prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户名"> </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="请输入密码" show-password>
              </el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button @click="handleSubmit" type="primary"
                style="width: 240px; background-color: #1f79ff; font-size: 18px; margin: 0 auto">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import http from '@/service/http.ts'
import JSEncrypt from 'jsencrypt'
import { router } from '@/router/router'

// const ssoIp = "http://172.21.92.68:18088/"
// const ssoIp = 'http://113.204.228.66:18085/'

export default {
  name: 'login',
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: '账号不能为空', trigger: 'blur' }]
      },
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
    },
  },
  data() {
    return {
      // ssoIp,
      showCode: false,
      qrcodeSrc: '',
      form: {
        userName: '',
        password: '',
      },
      logoSrc: require(`@/assets/linjiangheBlueLogo.png`),
    }
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules,
      }
    },
    title() {
      // return sessionStorage.getItem('appTitle')
      return '永川区流域数据监控系统'
    },
  },
  methods: {
    handleSubmit() {
      let userName = this.form.userName
      let password = this.form.password
      const _this = this
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          http
            .get(`${process.env.VUE_APP_BASE_URL}api/sso/RSA/getPublicKey?loginName=${userName}`)
            .then((res) => {
              if (res.data.msg && res.data.code === 200) {
                const rsaPass = _this.doEncryptor(res.data.msg, password)
                http
                  .post(`${process.env.VUE_APP_BASE_URL}api/sso/auth/login`, {
                    password: rsaPass,
                    username: userName,
                  })
                  .then((loginRes) => {
                    if (loginRes.data.data) {
                        sessionStorage.setItem('token', loginRes.data.data.access_token)
                        router.push('/main')
                    } else {
                      this.$message({
                        message: loginRes.data.msg,
                        type: 'error'
                      });
                    }
                  })
                  .catch((e) => {
                    console.log(e, '登录错误')
                  })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
                console.log(res.data, '错误异常')
              }
            })
            .catch((err) => {
              console.log(err, '---------获取公钥失败。')
            })
        }
      })
    },
    // rsa加密密码
    doEncryptor(pub, psd) {
      let encriptor = new JSEncrypt()
      encriptor.setPublicKey(pub)
      return encriptor.encrypt(psd)
    },
  },
}
</script>

<style lang="scss">
.login {
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/lgbg.png');
  background-size: cover;
  background-position: center;
  position: relative;

  .app_download {
    position: absolute;
    left: 20px;
    top: 20px;
    color: white;
    font-weight: bold;
    font-size: 18px;
  }

  .app_qrcode {
    position: absolute;
    left: 20px;
    top: 60px;

    img {
      width: 200px;
      height: 200px;
    }
  }

  &-con {
    position: absolute;
    top: 25%;
    left: 25%;
    transform: translateY(50%) translateX(50%);
    width: 520px;
    box-shadow: 1px 10px 20px #e2e2e2;

    .title {
      display: inline-block;
      width: 100%;
      height: auto;
      line-height: 46px;
      font-size: 24px;
      text-align: center;
      color: #1f79ff;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: 6px;
      white-space: nowrap;
      display: flex;
    }

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      padding: 10px 0 0;
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }
}
</style>
